/* eslint-disable promise/prefer-await-to-then */
/* eslint-disable promise/always-return */
import { TEventInputData } from '@/core/constants/event_types/additional_types';
import { EMableEventName } from '@/core/constants/event_types/events';
import { processEvent } from '@/core/event_logic/event_processor';
import { Logger } from '@/shared/logger/logger';

/**
 * The main entry point for handling all incoming events.
 * This function delegates the actual event processing to the event_processor module.
 *
 * @param eventName The event name
 * @param eventInputData The event input data
 * @returns A boolean indicating if the event was processed successfully in all destinations and the destinations that were processed.
 */
export async function handleEvent(
  eventName: EMableEventName,
  eventInputData: TEventInputData,
  alreadyProcessedDestinations: string[] = [],
) {
  try {
    const [finishedDestinations, success] = await processEvent(
      eventName,
      eventInputData,
      alreadyProcessedDestinations,
    );
    return {
      data: finishedDestinations,
      success,
    };
  } catch (error) {
    Logger.error('Error in handleEvent', error);
    return {
      data: [],
      success: false,
    };
  }
}
